Object.defineProperties(Date.prototype, {
    day: {
        configurable: true,
        get: function(): number {
            return this.getDay();
        }
    },
    time: {
        configurable: true,
        get: function(): number {
            return this.getTime();
        }
    }
});
